import { useCallback } from 'react'
import { get } from 'lodash'
import { useDispatch } from 'react-redux'
import { setFilterModel, setLocationId } from 'slices/configuredService/createDraftCSDSlice'

/**
 * Provides stable, named handlers used by CreateDraftServiceForm.
 */
export function useCreateDraftServiceHandlers() {
  const dispatch = useDispatch()

  const onFilterChange = useCallback(
    filterModel => {
      dispatch(setFilterModel(filterModel))
    },
    [dispatch]
  )

  const handleLocationChange = useCallback(
    newLocationId => {
      dispatch(setLocationId(newLocationId))
    },
    [dispatch]
  )

  const getLocationOptionLabel = useCallback(option => get(option, 'label', ''), [])

  const isLocationOptionEqualToValue = useCallback((option, value) => {
    if (!option) return false
    const optionId = option.id ?? option.value
    const valueId = (value && (value.id ?? value.value)) || value
    return optionId === valueId
  }, [])

  const handleLocationAutocompleteChange = useCallback(
    (onChange, item) => {
      onChange(item)
      const newId = item?.id ?? item?.value ?? ''
      handleLocationChange(newId)
    },
    [handleLocationChange]
  )

  return {
    onFilterChange,
    handleLocationChange,
    getLocationOptionLabel,
    isLocationOptionEqualToValue,
    handleLocationAutocompleteChange,
  }
}
